type AnyFunction = (...args: any[]) => any

export function intercept(target: any, name: string, newMethod: AnyFunction) {
  const orig = target[name]
  target[name] = (...args: any[]) => {
    const newArgs = newMethod.call(target, ...args) || args
    return orig.call(target, ...newArgs)
  }
}